import { memo, type FC } from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { RegionId } from "../types";

const denseItemSx = {
  display: "flex",
  alignItems: "center",
  ml: 0,
  my: 0,
  "& .MuiCheckbox-root": { py: 0.25 },
  "& .MuiFormControlLabel-label": { my: 0 },
} as const;

type GeoRegionsSelectorProps = {
  title?: string;
  action?: React.ReactNode;
  regions: Array<{ id: RegionId; label: string }>;
  selectedRegionIds: RegionId[];
  onToggle: (regionId: RegionId, checked: boolean) => void;
};

export const GeoRegionsSelector: FC<GeoRegionsSelectorProps> = memo(
  ({
    title = "Include Regions",
    action,
    regions,
    selectedRegionIds,
    onToggle,
  }) => {
    return (
      <Box>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 0.5 }}
        >
          <Typography variant="subtitle2" fontWeight={700}>
            {title}
          </Typography>
          {action}
        </Stack>
        {regions.map((region) => (
          <FormControlLabel
            key={region.id}
            control={
              <Checkbox
                id={`geography-region-checkbox-${region.id.toLowerCase()}`}
                size="small"
                checked={selectedRegionIds.includes(region.id)}
                onChange={(e) => onToggle(region.id, e.target.checked)}
                sx={{ pl: 0 }}
              />
            }
            label={<Typography variant="body2">{region.label}</Typography>}
            sx={denseItemSx}
          />
        ))}
      </Box>
    );
  }
);

GeoRegionsSelector.displayName = "GeoRegionsSelector";
